import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./pageHeader.module.css";
import { useTranslation } from "react-i18next";
import CustomizerContext from "../../../_helper/Customizer";
import icons from "../../../Data/icons";
import { Spinner } from "react-bootstrap";

const PageHeader = ({
  title,
  showButton,
  showBack,
  url,
  handleShowEditForm,
  isdisbled,
  toggleModal,  
  handleUpdateTaskPost,
  tasksData,
  handlePostRequest,
  saveButton,
  showSelect,
  onSelectChange,
  showProfile,
  EditButton,
  showEditBtn,
  upadteUrl,
  showEditRequest,
  handelEditRequest,
  showPayrollsSelect,
  isprint ,
  print,
  ExeclData,
  downloadExcelFile,
  isLoading
}) => {
  const {t ,i18n}= useTranslation()
  const navigate = useNavigate();
  const location = useLocation()
  const {layoutDir} =useContext(CustomizerContext);
  const Back = icons.back
  const RequestIcon =icons.pen
  const Save = icons.Save
  const User =icons.profile
  const Settings = icons.settings
  const PrintIcon =icons.print
  const PdfIcon = icons.pdf
  const EditIcon =icons.Edit
  const ExcelIcon =icons.execl
 const selectedlang = localStorage.getItem("i18nextLng")
  return (
    <div className="container-fluid">
  <div className="page-header">
      <div class="row">
        <div class="col-sm-6">
        <h3>{t(`${title}`)}</h3>
        {location.pathname === "/home" ?"" :<ol class="breadcrumb justify-content-start">
            <li class="breadcrumb-item">
              <a href="#" data-bs-original-title="" title="">
                {t("Home")}
              </a>
            </li>
            <li class="breadcrumb-item">{t(`${title}`)}</li>
          </ol>}  
        </div>
        <div class="col-sm-6 d-flex justify-content-end">
          {showButton && (
            <div class="bookmark">
              <ul>
                <li class="p-0">
                  <a
                    onClick={() => navigate(url)}
                    data-container="body"
                    data-bs-toggle="popover"
                    data-placement="top"
                    title=""
                    data-original-title="Chat"
                    data-bs-original-title=""
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-plus"
                    >
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </a>
                </li> 
              </ul>
            </div>
          )}
      
         {showPayrollsSelect&& <input className="form-control" type="date"/>

         }
          {showProfile && <button type="button" className={classes.BackBtn} onClick={()=>navigate(-1)}>
             <User/>
            </button>}
            {showEditBtn && <button type="button" className={classes.BackBtn} onClick={()=>navigate(upadteUrl)}>
             <EditIcon/>
            </button>}
            { showSelect&&  <select name="lang_code" className={classes.langSelect} onChange={onSelectChange}>
              <option id="1" value="ar" selected={selectedlang === "ar"}> العربية</option>
              <option  id="2" value="en" selected={selectedlang ==="en"}> English</option>
            </select>}
            {EditButton && <button type="button" className={classes.BackBtn} onClick={handleShowEditForm}>
             <Settings/>
            </button>}
            {showEditRequest && <button type="button" className={classes.BackBtn} onClick={handelEditRequest}>
             <RequestIcon/>
            </button>}
          
          {
            showBack && <button type="button" className={classes.BackBtn} onClick={()=>navigate(-1)}>
            Back  <Back/>
            </button>
          }
          {title === "الطلبات" && (
            <div class="bookmark">
              <ul>
                <li class="p-0">
                  <a
                    onClick={() => toggleModal(url)}
                    data-container="body"
                    data-bs-toggle="popover"
                    data-placement="top"
                    title=""
                    data-original-title="Chat"
                    data-bs-original-title=""
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-plus"
                    >
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          )}
           
         

           {isLoading ? <Spinner/> :<>  {saveButton&&  <button
              className={  `${classes.updateBtn} ${layoutDir === "ltr" &&classes.updateBtnLtr} ${isdisbled() && `${classes.disabled}` }`   }
              type="button"
              disabled={isdisbled()}
             onClick={handlePostRequest}
            >
            <Save/>
            </button>}
           </>}
            {isprint && 
           <>
           <button type="button" className={classes.updateBtn} onClick={()=>downloadExcelFile(ExeclData)}>
          <ExcelIcon/>
          </button>
          <button type="button" className={classes.updateBtn} onClick={()=>print()}>
          <PdfIcon/>
          </button>
           </> 
          
          }
          
         
          {tasksData && (
            <button
              className={   `${classes.updateBtn} ${layoutDir === "ltr" &&classes.updateBtnLtr}`    }
              type="button"
              disabled={tasksData.status==="On-Review"}
              onClick={handleUpdateTaskPost}
            >
              {tasksData.status}
            </button>
          )}
        </div>
      </div>
    </div>
    </div>
  
  );
};

export default PageHeader;
